<template>
	<div >
		<Row :gutter="10" style="margin-bottom: 20px">
			<Col>
			<div style="margin-left: 30px;">
				<Select placeholder="排序类型" v-model="order_type" @on-change="mySearch">
					<Option value="desc" :key="1">正序 </Option>
					<Option value="asc" :key="2">倒序 </Option>
				</Select>
			</div>
			</Col>
		</Row>
		<Table border :columns="columns" :data="datas"></Table>
	</div>
</template>

<script>
	import {
		getDistributeMonitorList
	} from "../../../api/admin";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		data() {
			return {
				columns: [{
						title: "排名",
						key: "ranking",
						align: 'center'
					},
					{
						title: "渠道",
						key: "channel_name",
						align: 'center'
					},
					{
						title: "余额",
						key: "balance",
						align: 'center'
					},
				],
				datas: [],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.order_type = that.order_type;
				let res = await getDistributeMonitorList(that, data);
				that.datas = res.data.list;
			},
		},
	};
</script>

<style lang="less" scoped>
/deep/ .ivu-table th {
  background: #277dd3;
  color: white;
}
/deep/ .ivu-table .table-blue-row td {
  color: #ff6699;
}
/deep/ .ivu-table .table-yellow-row td {
  color: #aaaa00;
}

/deep/ .ivu-table .table-black-row td {
  color: black;
}
	
</style>
